export const reactivateOktaUser = ({ token, userId }) => ({
  HTTPMethod: "post",
  path: `/api/v1/sso/users/${userId}/reactivate`,
  queryParams: { send_email: true },
  headers: {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});
